import actions from './actions'
export default {
  namespaced: true,
  state: () => ({
    loading: {},
  }),
  mutations: {
    START_LOADING(state, name) {
      state.loading[name] = true;
    },
    END_LOADING(state, name) {
      state.loading[name] = false;
    },
  },
  actions,
  getters: {
    isLoading: (state) => (name) => !!state.loading[name],
  },
};
